export default {

	init() {
		console.log('search init...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		$('select#filter-topics').on('change', function() {
			$(this).closest('form').submit();
		});
	}

}